import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import isHttpError from './util/isHttpError';
import createErrorResponse from './util/createErrorResponse';
import resolveByResponseErrors from './messageResolver/resolveByResponseErrors';
import findFirstNotNullCondition from './condition/findFirstNotNullCondition';
import defaultErrorMessageCondition from './condition/defaultErrorMessageCondition';
import networkErrorCondition from './condition/networkErrorCondition';
import responseErrorCondition from './condition/responseErrorCondition';
import responseStatusErrorCondition from './condition/responseStatusErrorCondition';
import tooManyRequestsErrorCondition from './condition/tooManyRequestsErrorCondition';
import maintenanceCondition from './condition/maintenanceCondition';
import { resolveErrorResponseDescription } from './condition/resolveErrorResponseDescription';
/**
 * @param {*} error
 * @param {HttpErrorMessageConfig} message
 *
 * @returns {Promise<?string>}
 */

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error, message) {
    var networkErrorMessage, errorResponse, conditions, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isHttpError(error)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", message.getDefault());

          case 2:
            _context.next = 4;
            return networkErrorCondition(error, message.getNetwork());

          case 4:
            networkErrorMessage = _context.sent;

            if (!networkErrorMessage) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", networkErrorMessage);

          case 7:
            errorResponse = createErrorResponse(error);
            conditions = [function () {
              return isFunction(message.getCustom()) ? message.getCustom()(errorResponse) : null;
            }, function () {
              return maintenanceCondition(errorResponse);
            }, function () {
              return responseErrorCondition(errorResponse, message.getErrorData());
            }, function () {
              return tooManyRequestsErrorCondition(errorResponse, message.getTooManyRequests());
            }, function () {
              return responseStatusErrorCondition(errorResponse, message.getStatus());
            }, function () {
              return resolveByResponseErrors(errorResponse);
            }, function () {
              return resolveErrorResponseDescription(errorResponse);
            }, function () {
              return defaultErrorMessageCondition(errorResponse);
            }];
            _context.next = 11;
            return findFirstNotNullCondition(conditions);

          case 11:
            errorMessage = _context.sent;
            return _context.abrupt("return", errorMessage !== null ? errorMessage : message.getDefault());

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();